import React from "react";
import { Phone, MessageCircle, ClipboardCheck } from "lucide-react";
import { Link } from "react-router-dom";

export default function MobileBottomBar({ settings }) {
    return (
        <div
            className="md:hidden fixed bottom-0 left-0 right-0 z-30 bg-white border-t border-lnl-border shadow-[0_-4px_10px_-6px_rgba(0,0,0,0.08)]"
            data-testid="mobile-bottom-bar"
        >
            <div className="grid grid-cols-3">
                <a
                    href={`tel:${(settings?.mobile || "").replace(/[^0-9+]/g, "")}`}
                    className="flex flex-col items-center justify-center gap-1 py-3 text-lnl-charcoal"
                    data-testid="bottom-call"
                >
                    <Phone className="h-5 w-5 text-lnl-green" />
                    <span className="text-[11px] font-heading font-semibold">Call</span>
                </a>
                <Link to="/contact" className="flex flex-col items-center justify-center gap-1 py-3 text-lnl-charcoal" data-testid="bottom-ask">
                    <MessageCircle className="h-5 w-5 text-lnl-green" />
                    <span className="text-[11px] font-heading font-semibold">Ask</span>
                </Link>
                <Link to="/admissions/apply" className="flex flex-col items-center justify-center gap-1 py-3 bg-lnl-green text-white" data-testid="bottom-apply">
                    <ClipboardCheck className="h-5 w-5" />
                    <span className="text-[11px] font-heading font-semibold">Apply</span>
                </Link>
            </div>
        </div>
    );
}
